import { render, staticRenderFns } from "./app-message.vue?vue&type=template&id=19042e0e&scoped=true&"
import script from "./app-message.vue?vue&type=script&lang=js&"
export * from "./app-message.vue?vue&type=script&lang=js&"
import style0 from "./app-message.vue?vue&type=style&index=0&id=19042e0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19042e0e",
  null
  
)

export default component.exports